module.exports = __webpack_public_path__ + "assets/img/00074.5b52d44c.png";